// extracted by mini-css-extract-plugin
module.exports = {"BigButton":"ButtonRes_BigButton__3hJSW","Link":"ButtonRes_Link__im5_x"};